export const PAGE_MODE = {
  HISTORY: "history",
  WIZARD: "wizard",
};

export const STEPS = {
  UPLOAD: "upload",
  FILE_PROCESSING: "file_processing",
  AI_PROCESSING: "ai_processing",
  VALIDATION: "validation",
  MAPPING: "mapping",
  DUPLICATES: "duplicates",
  SUCCESS: "success",
};

export const WIDE_STEPS = [STEPS.MAPPING, STEPS.DUPLICATES];

export const LOCKED_STEPS = [STEPS.FILE_PROCESSING, STEPS.AI_PROCESSING];

export const FILE_PROCESS_ITEMS = [
  { id: "upload", label: "Uploading file..." },
  { id: "validate", label: "Validating data..." },
  { id: "duplicates", label: "Checking for duplicates..." },
];

/** Fake validate / duplicate checklist duration after real upload finishes. */
export const FILE_PROCESS_FAKE_STEP_MS = 1500;

export const IMPORT_STATUS = {
  OPEN: "Open",
  DRAFT: "Draft",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
  FAILED: "Failed",
};

export const CONFIDENCE = {
  HIGH: "High",
  MEDIUM: "Medium",
  LOW: "Low",
};

export const FILE_DUP_POLICIES = [
  { value: "first", label: "Keep first occurrence" },
  { value: "last", label: "Keep last occurrence" },
  { value: "skip", label: "Skip all duplicates" },
];

export const CRM_DUP_POLICIES = [
  { value: "skip", label: "Skip duplicates" },
  { value: "update", label: "Update existing leads" },
];

export const FILE_DUP_STRATEGY = {
  first: 1,
  last: 2,
  skip: 3,
};

export const CRM_DUP_STRATEGY = {
  skip: 1,
  update: 2,
};

export const CREATE_CUSTOM_FIELD_VALUE = "__create_custom_field__";

export const DEFAULT_FILE_POLICY = "first";
export const DEFAULT_CRM_POLICY = "skip";

export const EMPTY_DUPLICATE_SUMMARY = {
  unique: 0,
  fileDuplicates: 0,
  crmDuplicates: 0,
};

export const EMPTY_SUCCESS_SUMMARY = {
  total: 0,
  imported: 0,
  updated: 0,
  skipped: 0,
  processed: 0,
  processedNotes: [],
};

export const DEFAULT_SUCCESS_NOTES = [
  "Leads imported according to your field mapping",
  "Duplicate leads handled according to your preferences",
  "Data mapped to CRM fields",
];

/** Client/gateway timeout for validate-and-prepare + execute only (10K rows). */
export const IMPORT_LONG_TIMEOUT_MS = 10 * 60 * 1000;

export const IMPORT_POLL_INTERVAL_MS = 4000;

export const MAX_FILE_MB = 10;

export const FILE_ACCEPT =
  ".csv,.xlsx,.xls,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel";
